export const DEFAULT_APP_TITLE = 'Portfolio Builder';
